import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, X } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  city: 'Buenos Aires',
  product: 'Colección Vikingos Legendarios',
  time: 'hace 3 min'
}, {
  name: 'Carlos R.',
  city: 'Córdoba',
  product: 'Colección Vikingos Legendarios',
  time: 'hace 5 min'
}, {
  name: 'Luciana F.',
  city: 'Rosario',
  product: 'Colección Vikingos Legendarios',
  time: 'hace 8 min'
}, {
  name: 'Fernando D.',
  city: 'Mendoza',
  product: 'Colección Vikingos Legendarios',
  time: 'hace 12 min'
}, {
  name: 'Valentina S.',
  city: 'La Plata',
  product: 'Colección Vikingos Legendarios',
  time: 'hace 15 min'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (isDismissed) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, 1000);
    }, 7000);
    return () => clearInterval(interval);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 max-w-[260px]" data-id="element-249">
      <AnimatePresence data-id="element-250">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-dark-card border border-dark-border rounded-lg p-2.5 shadow-[0_4px_20px_rgba(0,0,0,0.5)] flex items-start gap-2" data-id="element-251">
            <div className="shrink-0 w-7 h-7 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-252">
              <BookOpen className="w-3.5 h-3.5 text-gold" data-id="element-253" />
            </div>

            <div className="flex-grow min-w-0" data-id="element-254">
              <p className="text-white text-xs font-semibold leading-tight" data-id="element-255">
                {purchase.name}{' '}
                <span className="text-gray-400 font-normal" data-id="element-256">de</span>{' '}
                <span className="text-gold-light" data-id="element-257">{purchase.city}</span>
              </p>
              <p className="text-gray-400 text-[10px] mt-0.5 leading-tight" data-id="element-258">
                Adquirió el{' '}
                <span className="text-gray-300" data-id="element-259">{purchase.product}</span>
              </p>
              <p className="text-gray-500 text-[10px] mt-0.5" data-id="element-260">
                {purchase.time}
              </p>
            </div>

            <button onClick={() => setIsDismissed(true)} className="shrink-0 text-gray-400 hover:text-gray-300 transition-colors" aria-label="Cerrar notificación" data-id="element-261">
              <X className="w-3.5 h-3.5" data-id="element-262" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}